import { Component, Input } from '@angular/core';
import { WebPaths } from '@partner/shared/SharedConstants';
import { InactivityPanelVariant, InactivityPanelVm } from '../../../../domain/model/executive-snapshot.model';

/**
 * Inactivity banner with the progress toward the 90-day deactivation. Warning variant from 30 days;
 * empty variant ("No submissions yet") when the partner has no qualifying submission at all.
 */
@Component({
  selector: 'ifbp-inactivity-panel',
  templateUrl: './inactivity-panel.component.html',
  styleUrls: ['./inactivity-panel.component.scss'],
  standalone: false,
})
export class InactivityPanelComponent {
  @Input() vm: InactivityPanelVm;

  readonly Variant = InactivityPanelVariant;
  readonly WebPaths = WebPaths;
}
